import React from 'react';
import { createRoot } from 'react-dom/client';
import { Canvas } from '@react-three/fiber';
import { MathematicalManifold } from './MathematicalManifold';
import { PostProcessing } from './PostProcessing';

const Background = () => {
  return (
    <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0, pointerEvents: 'auto', background: '#0B132B' }}>
      <Canvas
        gl={{ antialias: false, alpha: false }}
        camera={{ position: [0, 0, 15], fov: 45 }}
        dpr={Math.min(window.devicePixelRatio, 2)} // Limit DPR for performance
      >
        <color attach="background" args={['#0B132B']} />
        <MathematicalManifold />
        <PostProcessing />
      </Canvas>
    </div>
  );
};

const rootElement = document.getElementById('react-background-root');
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(<Background />);
}
